import React, { useEffect, useRef, useState } from "react"
import { useOnClickOutside } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter  } from 'react-router-dom';
import Input from "../../components/utils/Input";
import { refundArticle, setDetailArticle } from "../../action/cassa";
import { urls } from "../../constants/app";
import { modalsSelector } from "../../selectors";
import request from "../../action/utils/request";
import moment from "moment";
import swal from 'sweetalert';
import ErrorContainer from "../../components/utils/ErrorContainer";

const WorkingShiftRefundArticles = () => {
    const ref = useRef();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.info);
    const cities = useSelector(state => state.handbook.cities);
    const props = useSelector(modalsSelector).workingShiftRefundArticles;

    const { article, workingShiftId, point } = props;

    const [sendedData, setSendedData] = useState({
        data: {
            article: {
                created_at: null,
                name: article.name,
                sum: article.sum,
                typeMovementCash: article.typeMovementCash === 'income' ? 'expenditure' : 'income',
                typeTransaction: article.typeTransaction,
                author: user.name ? user.name : user.username,
                comment: null,
                visible_datetime: new Date(),
            },
            workingShiftId: null,
        },
        refunded: {
            id: article.id,
            workingShiftId: workingShiftId,
        }
    });

    useEffect(() => {
        const getData = async () => {
            let timeZone = '+03';
            if(point && point.city) {
                let city = null;
                city = (point.city && point.city.id) ? point.city : cities.find((item) => item.id === point.city);
                if (!city) city = await request({ method: 'get', url: `${urls.cities}/${point.city}` });
                timeZone = city.timeZone ? city.timeZone : '+03';
            }
            const time = parseInt(timeZone, 10) || 3;
            const created_at = moment.utc().add(parseInt(time, 10), 'hours').format('HH:mm DD.MM.YYYY');

            const params = {
                'point.id': point.id,
                closed_at_null: true,
            }
            const openShifts = await request({ method: 'get', url: urls.workingShift, params });
            const newWorkingShift = openShifts ? openShifts[0] : null;
            if (!newWorkingShift) return swal({
                title: "Смена закрыта",
                text: "Не найдено открытых смен для возврата, откройте смену и повторите попытку",
                icon: "warning",
                button: "Ок",
            });
            setSendedData({
                ...sendedData,
                data: {
                    ...sendedData.data,
                    article: { ...sendedData.data.article, created_at },
                    workingShiftId: newWorkingShift ? newWorkingShift.id ? newWorkingShift.id : newWorkingShift : null,
                }
            });
        };
        
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onClose = () => {
        dispatch(setDetailArticle(null));
        dispatch(setActiveModalAction({ field: 'workingShiftRefundArticles', value: null }));
    };
    
    useOnClickOutside(ref, onClose);

    const onSubmit = async () => {
        const result = await dispatch(refundArticle(sendedData));
        if (result && !result.error) return onClose();
    }

    const setDataArticle = (field) => (e) => {
        const updated = {...sendedData};
        updated.data.article[field] = e.target.value;
        setSendedData(updated);
    }

    return(
        <form>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div ref={ref} className="modal-content" style={{ maxHeight: '600px', height: '600px' }}>
                        <div className="modal-header">
                            <h5 className="modal-title"> Возврат статьи </h5>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body">
                            <div style={{ color: '#000' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                    <div>Тип: {article.typeTransaction === 'cash' ? 'Наличные' : 'Безнал.'}</div>
                                </div>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                    <div>Статья: {article.name}</div>
                                </div>
                                <div className="form-group">
                                    <div>Сумма: {article.sum}</div>
                                </div>
                            </div>
                            <Input
                            label='Примечание'
                            textarea={true}                            
                            onChange={setDataArticle('comment')}
                            value={sendedData.data.article.comment}
                            placeholder='Примечание'
                            />
                        </div>
                        <ErrorContainer field="workingShift" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Закрыть</button>
                            <button type="button" onClick={onSubmit} className='btn btn-primary'>Возврат</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default withRouter(WorkingShiftRefundArticles);